import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

interface TabItem {
  key: string;
  label: string;
}

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent {
  public readonly tabs = input.required<TabItem[]>();
  public readonly activeTab = model.required<string>();

  public readonly fullWidth = input(false);
  public readonly centered = input(false);

  public onTabChange(tabKey: string): void {
    this.activeTab.set(tabKey);
  }
}
